import React from 'react';

import { Typography, WDSButton } from 'wanderu-components';

import styles from './MapDiscoveryBanner.scss';

interface MapDiscoveryBannerProps {
    onOpen: () => void;
}

function MapDiscoveryBanner({ onOpen }: MapDiscoveryBannerProps) {
    return (
        <div className={styles.banner}>
            <Typography className={styles.title} variant="h6">
                See where each trip picks up and drops off.
            </Typography>
            <WDSButton
                className={styles.button}
                onClick={onOpen}
                size="small"
            >
                View map
            </WDSButton>
        </div>
    );
}

export default React.memo(MapDiscoveryBanner);
